//import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer } from "@googlemaps/markerclusterer";

import CommunityMap from "./lib/components/community-map";
import CommunitySearchFilters from "./lib/components/community-search-filters";

import './modal-gallery-v2';

window.communitySearchMapJsonV2 = [
    {
        "NodeGUID": "00000000-1111-2222-3333-000000000001",
        "Name": "36th & Holt",
        "Brand": "shea",
        "Lat": 33.727629,
        "Long": -117.811157,
        "City": "Irvine",
        "State": "CA",
        "BedroomsMin": 1,
        "BedroomsMax": 3,
        "BathroomsMin": 1,
        "BathroomsMax": 2,
        "HalfBathsMin": 0,
        "HalfBathsMax": 0,
        "NumAvailableQMI": 0,
        "PriceMinString": "Priced From $200,000",
        "PricedFromString": "Anticipated Pricing from $199,999",
        "SquareFeetMin": 1250,
        "SquareFeetMax": 3850,
        "StoriesMin": 2,
        "StoriesMax": 2,
        "Url": "https://www.google.com",
        "HomeTypes": ["Type 1", "Type 3"],
        "Features": ["Feature 1", "Feature 2"],
        "ImageUrl": "https://embed.widencdn.net/img/sheahomes/o3rd34sojb/370x240px@1x/Trilogy_Summerlin_Plan_Explore_Elev_A.jpg?q=100",
        "Status": "Open"
    },
    {
        "NodeGUID": "00000000-1111-2222-3333-000000000002",
        "Name": "Aperture at Gateway Quarter",
        "Brand": "trilogy",
        "Lat": 33.675609,
        "Long": -117.605464,
        "City": "Orange",
        "State": "CA",
        "BedroomsMin": 2,
        "BedroomsMax": 3,
        "BathroomsMin": 2,
        "BathroomsMax": 3,
        "HalfBathsMin": 0,
        "HalfBathsMax": 2,
        "NumAvailableQMI": 8,
        "PriceMinString": "Anticipated Pricing from $550,000",
        "PricedFromString": "Anticipated Pricing from $399,999",
        "SquareFeetMin": 200,
        "SquareFeetMax": 4100,
        "StoriesMin": 1,
        "StoriesMax": 2,
        "Url": "https://www.google.com",
        "HomeTypes": ["Type 2", "Type 3"],
        "Features": ["Feature 2"],
        "ImageUrl": "https://embed.widencdn.net/img/sheahomes/5ljc9ohqqc/584x376px/Ascent_4014_Kitch.jpeg?position=c&crop=true&color=ffffffff&u=e3tgab",
        "Status": "Open"
    },
    {
        "NodeGUID": "00000000-1111-2222-3333-000000000003",
        "Name": "Ascent at Eastmark",
        "Brand": "shea",
        "Lat": 32.988593,
        "Long": -117.181460,
        "City": "San Diego",
        "State": "CA",
        "BedroomsMin": 1,
        "BedroomsMax": 3,
        "BathroomsMin": 1,
        "BathroomsMax": 2,
        "HalfBathsMin": 2,
        "HalfBathsMax": 3,
        "NumAvailableQMI": 5,
        "PriceMinString": "Pricing Coming Soon",
        "PricedFromString": "Pricing from $549,999",
        "SquareFeetMin": 1250,
        "SquareFeetMax": 3850,
        "StoriesMin": 2,
        "StoriesMax": 2,
        "Url": "https://www.google.com",
        "HomeTypes": ["Type 1", "Type 3"],
        "Features": ["Feature 1", "Feature 2"],
        "ImageUrl": "https://embed.widencdn.net/img/sheahomes/9x8offadpz/584x376px/Balmoral_Plan4039_Kitchen.jpeg?position=c&crop=true&color=ffffffff&u=e3tgab",
        "Status": "Closing Out"
    },
    {
        "NodeGUID": "00000000-1111-2222-3333-000000000004",
        "Name": "Briar Square at Mountain House",
        "Brand": "trilogy",
        "Lat": 32.817912,
        "Long": -116.773035,
        "City": "Alpine",
        "State": "CA",
        "BedroomsMin": 2,
        "BedroomsMax": 3,
        "BathroomsMin": 2,
        "BathroomsMax": 3,
        "HalfBathsMin": 1,
        "HalfBathsMax": 2,
        "NumAvailableQMI": 0,
        "PriceMinString": "Priced from $550,000",
        "PricedFromString": "Pricing Coming Soon",
        "SquareFeetMin": 200,
        "SquareFeetMax": 4100,
        "StoriesMin": 1,
        "StoriesMax": 2,
        "Url": "https://www.google.com",
        "HomeTypes": ["Type 2", "Type 3"],
        "Features": ["Feature 2"],
        "ImageUrl": "https://embed.widencdn.net/img/sheahomes/t9dzw636js/584x376px/Harmony_Vivace_Plan_4132_Grt_Rm_E.jpeg?position=c&crop=true&color=ffffffff&u=e3tgab",
        "Status": "Open"
    },
    {
        "NodeGUID": "00000000-1111-2222-3333-000000000005",
        "Name": "Cane Island",
        "Brand": "shea",
        "Lat": 32.817912,
        "Long": -116.773035,
        "City": "Alpine",
        "State": "CA",
        "BedroomsMin": 2,
        "BedroomsMax": 3,
        "BathroomsMin": 2,
        "BathroomsMax": 3,
        "HalfBathsMin": 1,
        "HalfBathsMax": 3,
        "NumAvailableQMI": 8,
        "PriceMinString": "Priced from $750,000",
        "PricedFromString": "Pricing from $789,999",
        "SquareFeetMin": 700,
        "SquareFeetMax": 4500,
        "StoriesMin": 2,
        "StoriesMax": 2,
        "Url": "https://www.google.com",
        "HomeTypes": ["Type 2"],
        "Features": ["Feature 3"],
        "ImageUrl": "https://embed.widencdn.net/img/sheahomes/o3rd34sojb/370x240px@1x/Trilogy_Summerlin_Plan_Explore_Elev_A.jpg?q=100",
        "Status": "Hold"
    }
];



/**
 * Module code for the COMMUNITY MAP AND LISTING module (map and results)
 * 
 * 
 */
class CommunitySearch {
    /**
     * 
     * @param {jQqueryElement} moduleElem Parent element associated with entire module containing the form filter
     * @param {jQqueryElement} cardListingModuleElem Parent element that contains the card listing
     */
    constructor(moduleElem, cardListingModuleElem) {
        this.COMMUNITY_SEARCH_ELEM = moduleElem;
        // Form Filter Elemenet
        this.COMMUNITY_SEARCH_FILTER_FORM = $(".home-search-form-wrapper form");
        // Map Element
        this.COMMUNITY_SEARCH_MAP_ELEM = this.COMMUNITY_SEARCH_ELEM.find("#region-communities-map-v2");
        this.ENDPOINT = "/api/modules/regionsearchandmap/getCommunities";
        this.COMMUNITY_SEARCH_COMMUNITY_DATA_ELEM = this.COMMUNITY_SEARCH_ELEM.find("#hiddenHomeSearchFormData");
        this.COMMUNITY_SEARCH_APPLY_FILTERS_BTN_ELEM = this.COMMUNITY_SEARCH_FILTER_FORM.find(".home-search-apply-filters");
        // Results Elements
        this.COMMUNITY_SEARCH_RESULTS_ELEM = cardListingModuleElem;
        this.COMMUNITY_SEARCH_RESULTS_LIST_ELEM = this.COMMUNITY_SEARCH_RESULTS_ELEM.find(".card-listing-container");
    }

    /**
     * Returns the base url path for icons used within the map
     */
    static get ICON_BASE_URL() {
        let host = "//" + window.location.host;
        let iconBase = host + "/patternlibrary/dist/assets/img/maps/";
        if (IS_LOCALHOST === true) {
            iconBase = host + "/assets/img/maps/";
        }
        return iconBase;
    } 

    /**
     * Returns the size of the icon (width and height are the same)
     */
    static get ICON_SIZE() {
        return 28;
    }

    /**
     * Init function that invokes other init functions to initialize the map and filters
     * and to request the intial batch of filtered communties
     */
    init() {
        const _THIS = this;
        _THIS.initMap();
        _THIS.initFilters();
        _THIS.initMapKeyboardA11y();
    }

    /**
     * Initializes the filters in thte community listing for this module
     */
    initFilters() {
        const _THIS = this;
        
        CommunitySearchFilters.initFilters();
        // set apply filters click listener
        CommunitySearchFilters.setOnApplyFiltersClickHandler(_THIS.buildGetCommunitiesFunc());
    }

    /**
     * Initializes keyboard accessibility features for the community search functionality.
     * 
     * This function addresses accessibility challenges posed by the Google Maps iframe, which
     * is largely inaccessible to keyboard users and cannot be modified directly due to security
     * restrictions. To prevent users from inadvertently tabbing to the iframe, the function 
     * ensures that keyboard focus skips over the map and moves directly to the next focusable 
     * element (the sort dropdown).
     * 
     * The implementation complies with WCAG, as equivalent accessible alternatives 
     * to the map's interactive features are provided. This includes ensuring that the search results 
     * are accessible without interacting with the map.
     * 
     * @function initMapKeyboardA11y
     * 
     * @example
     * // Initialize keyboard accessibility for the community search
     * initMapKeyboardA11y();
     */
    initMapKeyboardA11y() {
        // Set a timeout to ensure all elements are present in the DOM
        setTimeout(() => {
            const _THIS = this;
            // The desktop search button element within the home search form container
            const SEARCH_BTN = _THIS.COMMUNITY_SEARCH_APPLY_FILTERS_BTN_ELEM[0];
            // The mobile search form dropdown element within the home search form container
            const MOBILE_SEARCH_DROPDOWN = _THIS.COMMUNITY_SEARCH_ELEM[0].querySelector('.home-search-refine-filters');
            // The sort dropdown element within the community market area listing
            const SORT_DROPDOWN = _THIS.COMMUNITY_SEARCH_RESULTS_ELEM[0].querySelector('.select2-selection--single');

            // Bail if none of the required elements are present
            if (!SEARCH_BTN || !MOBILE_SEARCH_DROPDOWN || !SORT_DROPDOWN) {
                return;
            }

            /**
             * Manages focus movement between the sort dropdown and the search elements (desktop and mobile).
             * 
             * This function adds a keydown event listener to the `SORT_DROPDOWN` element. 
             * When the Tab key is pressed while the Shift key is held down, focus moves back to 
             * the appropriate element based on the device (desktop or mobile). If on a desktop, 
             * focus returns to the search button. If on a mobile device, focus returns to the 
             * mobile search dropdown.
             * 
             * @function handleSortDropdownFocus
             * 
             * @example
             * // Call this function to initialize the focus management for the sort dropdown
             * handleSortDropdownFocus();
             */
            const handleSortDropdownFocus = () => {
                // Add keydown event listener to the sort dropdown
                SORT_DROPDOWN.addEventListener("keydown", (e) => {
                    // If the Tab key is pressed and Shift is held down
                    if (e.key === "Tab" && e.shiftKey) {
                        e.preventDefault();         
                        
                        // Check if user is on a mobile device
                        if (window.matchMedia("(max-width: 640px").matches) {
                            // Focus the mobile search dropdown
                            MOBILE_SEARCH_DROPDOWN.focus();
                        } else {
                            // Focus the desktop search button
                            SEARCH_BTN.focus();
                        }
                    }
                });
            }

            // Add keydown event listener to the search button
            SEARCH_BTN.addEventListener("keydown", (e) => {
                // If the Tab key is pressed while Shift is not held down, focus moves to the sort dropdown
                if (e.key === "Tab" && !e.shiftKey) {
                    e.preventDefault();
                    SORT_DROPDOWN.focus();
                }
            });

            // Add keydown event listener to the mobile search form dropdown
            MOBILE_SEARCH_DROPDOWN.addEventListener("keydown", (e) => {
                // If the Tab key is pressed while Shift is not held down, focus moves to the sort dropdown
                if (e.key === "Tab" && !e.shiftKey) {
                    e.preventDefault();
                    SORT_DROPDOWN.focus();
                }
            });

            handleSortDropdownFocus();
        }, 1000); 
    }

    /**
     * 
     * @returns 
     */
    async initMap() {
       const _THIS = this;
        
        // Set the global map reference
        var mapElement = _THIS.COMMUNITY_SEARCH_MAP_ELEM[0];
        if (mapElement == null) {
            return;
        }

        // See: https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        const { Map } = await  google.maps.importLibrary('maps');

        // Pull the map id from the hidden field, use this in the mapId property in MAP_OPTIONS (if specified).
        // When MAP_OPTIONS.mapId (lower case d) is specified, the styles from the online map profile is used instead of the MAP_OPTIONS.styles property
        var mapID = $("#region-map-id").val();
        var mapStyles = [
            {elementType: 'geometry', stylers: [{saturation: '-75'}]},
            {featureType: 'road',elementType: 'geometry',stylers: [{saturation: '-75'}]},
            {featureType: 'road',elementType: 'geometry.stroke',stylers: [{saturation: '-75'},{color: '#c9c1a9'}]},
            {featureType: 'road.highway',elementType: 'geometry',stylers: [{saturation: '-75'}]},
            {featureType: 'road.highway',elementType: 'geometry.stroke',stylers: [{saturation: '-75'},{color: '#c9c1a9'}]},
            {featureType: 'transit',elementType: 'geometry',stylers: [{saturation: '-75'}]},
        ]
        if (mapID && mapID.length > 0)
        {
            mapStyles = null;
        } else 
        {
            mapID = null;
        }

        const MAP_OPTIONS = {
            zoom: 50,
            mapTypeId: 'roadmap',
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            mapId: mapID,
            styles: mapStyles,
            clickableIcons: false,   // disable clicking of landmarks
            disableDoubleClickZoom: true    // disable double click to zoom within map
        };

        CommunityMap._map = new Map(mapElement, MAP_OPTIONS);

        // Set map to default center and zoom and record this setting for later use
        var center = new google.maps.LatLng(CommunityMap.DEFAULT_INITIAL_POSITION_LAT, CommunityMap.DEFAULT_INITIAL_POSITION_LONG);
        var zoom = CommunityMap.DEFAULT_INITIAL_ZOOM;
        CommunityMap._map.setCenter(center);
        CommunityMap._map.setZoom(zoom);
        CommunityMap.setMapCenterAndZoom(center, zoom);

        // Create Legend only if this is the first initialization (ie.g., not updating markers)
        var legend = document.getElementById("region-communities-legend");
        if (legend != null) {
            CommunityMap._map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);
        }

        // Create view more on click listener to update the side results section
        // _THIS.COMMUNITY_SEARCH_ELEM.find(".view-more-communities").click(function () {
        //     _THIS.fyhSearchResultsViewMore();
        // });

        _THIS.COMMUNITY_SEARCH_RESULTS_ELEM.find("#sort-dropdown").change(function(){
            _THIS.sortCommunityCardsDOM();
            _THIS.resetSearch();
            CommunityMap.initPricingTooltips(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find("[data-tooltip]"));
        });

        // Create click listener to Recenter Map
        // _THIS.COMMUNITY_SEARCH_ELEM.find(".fyh-search-map_recenter-btn").on("click", function(e){
        //     e.preventDefault();
        //     CommunityMap.resetMapCenterAndZoom();

        //     // Close any active info window and reset the active window
        //     if( CommunityMap._activeCommunityPopups ) {
        //         CommunityMap._activeCommunityPopups.close();
        //         CommunityMap._activeCommunityPopups = null;
        //     }

        //     // since listing will shift based on map movement, show preloader
        //     showPreLoader(_THIS.COMMUNITY_SEARCH_ELEM);

        // });

        // When the user moves out of the map clear all of the info windows
        google.maps.event.addListener(CommunityMap._map, 'mouseout', function () {
            CommunityMap.closeCommunityPopups();
        });

        // Set helper variables to point to map icons based on environment
        var host = "//" + window.location.host;
        var iconBase = host + "/patternlibrary/dist/assets/img/maps/";
        if (IS_LOCALHOST === true) {
            iconBase = host + "/assets/img/maps/";
        }

        // init the rest of the results and the data (unlike FYH there
        // is no deferred loading of data here)
        this.initMapAndData(false);
    }

    /**
     *
     * @param {*} onlyUpdateData
     */
    initMapAndData(onlyUpdateData = false) {
        const _THIS = this;

        // Set the global map reference
        var mapElement = _THIS.COMMUNITY_SEARCH_MAP_ELEM[0];
        if (mapElement == null) {
            return;
        }

        // By page load, the backend should have populated the hidden field with map data
        // Store in hidden field then force refresh
        if (IS_LOCALHOST === false) {
            var jsonData = JSON.parse(_THIS.COMMUNITY_SEARCH_COMMUNITY_DATA_ELEM.val());

            if (jsonData) {
                window.communitySearchMapJsonV2 = jsonData;
            }
        }

        // Update the num results label which is based on the number of currently visible items
        if (communitySearchMapJsonV2 != null) {
            // Update the number of results based on the number of DOM elements (which indicates total number of query results)
            this.updateDisplayCount();
        }
        else {
            $(".home-search-form-num-results, .search-results-cards-num-results, .search-results-cards-num-results-v2").text("0 Community Results");
        }


        // Icon map for communities
        var communityIcons = {
            shea: {
                url: CommunitySearch.ICON_BASE_URL + 'single-community-pin-green-2x.png',
                scaledSize: new google.maps.Size(CommunitySearch.ICON_SIZE, CommunitySearch.ICON_SIZE), // scaled size
            },
            trilogy: {
                url: CommunitySearch.ICON_BASE_URL + 'single-community-pin-green-2x.png',
                scaledSize: new google.maps.Size(CommunitySearch.ICON_SIZE, CommunitySearch.ICON_SIZE), // scaled size
            }
        };

        // Clear markers and info windows from map if any and reset array and reset any active
        // markers/labels
        CommunityMap.clearMarkers(CommunityMap._markers);
        CommunityMap._markers = [];
        CommunityMap.closeCommunityPopups();

        // Build list of community names as ordered by the server (look at the DOM order)
        CommunityMap._communityGuidsSorted = [];
        // _THIS.COMMUNITY_SEARCH_ELEM.find(".search-results_wrapper-cell .card-community").each(function(){
        //     CommunityMap._communityGuidsSorted.push($(this).text());
        // });

        // Force sort dropdown to be at the default Alpha (a-z) sort option
        var sortDropdown = _THIS.COMMUNITY_SEARCH_ELEM.find("#sort-dropdown");;
        sortDropdown.prop('selectedIndex', 0);

        // This will be used to incrementally extend the bounds of the map
        // give each markers location to make sure map includes all markers
        var bounds = new google.maps.LatLngBounds();

        // For each region (should only be one for this map), loop through each community and
        // display markers for each community in the region. Also, continue to adjust maps bounds
        // to cover all markers
        communitySearchMapJsonV2.forEach(function (community) {
            let communityName = community["Name"],
                communityPosition = new google.maps.LatLng(community["Lat"], community["Long"]),
                communityPrice = community["PriceMinString"],
                communityPricedFrom = community["PricedFromString"],
                communityUrl = community["Url"],
                homeTypes = community["HomeTypes"],
                communityCity = community["City"],
                communityState = community["State"],
                communityBedMin = community["BedroomsMin"],
                communityBedMax = community["BedroomsMax"],
                communityBathMin = community["BathroomsMin"],
                communityBathMax = community["BathroomsMax"],
                communityStoryMin = community["StoriesMin"],
                communityStoryMax = community["StoriesMax"],
                communityHalfBathMin = community["HalfBathsMin"],
                communityHalfBathMax = community["HalfBathsMax"],
                communityNumAvailableQMI = community["NumAvailableQMI"],
                communityNodeGuid = community["NodeGUID"],
                communityImageUrl = community["ImageUrl"],
                communityStatus = community["Status"];

            // build icon path with guid parameter to facilitate icon look up later in code
            var communityIcon = (community.brand == "trilogy" ? communityIcons["trilogy"] : communityIcons["shea"]);
            communityIcon.url += `?guid=${communityNodeGuid}`;
            console.log("community-search.js Community Status is " + communityStatus);

            // Create the marker (and give each marker a customInfo object)
            var marker = new google.maps.Marker({
                position: communityPosition,
                icon: communityIcon,
                map: CommunityMap._map,
                customInfo: {
                    name: communityName,
                    position: communityPosition,
                    price: communityPrice,
                    pricedFrom: communityPricedFrom,
                    url: communityUrl,
                    homeTypes: homeTypes,
                    city: communityCity,
                    state: communityState,
                    bedmin: communityBedMin,
                    bedmax: communityBedMax,
                    bathmin: communityBathMin,
                    bathmax: communityBathMax,
                    halfbathmin: communityHalfBathMin,
                    halfbathmax: communityHalfBathMax,
                    qmicount: communityNumAvailableQMI,
                    storymin: communityStoryMin,
                    storymax: communityStoryMax,
                    nodeGuid: communityNodeGuid,
                    imageUrl: communityImageUrl,
                    status: communityStatus
                }
            });

            // Adjust the bounds
            bounds.extend(marker.getPosition());

            // Create InfoWindow popup on click event for mobile or mouseover for desktop
            var eventName = 'click';
            if (Foundation.MediaQuery.atLeast('xlarge')) {
                eventName = "mouseover";
            }

            // Add event listener to open marker info window
            google.maps.event.addListener(marker, eventName, function (evt) {
                var guid = marker.customInfo.nodeGuid;
                var infoWin = CommunityMap._communityPopups[guid];
                CommunityMap.closeCommunityPopups(false);
                if( infoWin ) {
                    CommunityMap.highlightActiveCommunityIcon(guid);

                    infoWin.open();
                    CommunityMap._activeCommunityPopups = infoWin;
                }

            });

            // Reset active marker on marker mouse out
            google.maps.event.addListener(marker, "mouseout", function (evt) {
                CommunityMap.highlightActiveCommunityIcon(null);
            });

            // Add the markers and adjust the maps bound with padding 
            // on the top and bottom div_ the map to minimize change that
            // markers appear at the very bottom of the map under the fold
            CommunityMap._markers.push(marker);
            CommunityMap._map.fitBounds(bounds, {
                top: 80,
                bottom: 80
            });
        });

        // Create cluster if initializing map for first time. Afterwards just clear markers and add new ones
        // to ensure cluster only shows the latest communites from the CommunityMap.fyhSearchMapMarkers array
        if (CommunityMap._clusterer == null) {
            const CLUSTERER_OPTIONS = {
                map: CommunityMap._map,
                markers: CommunityMap._markers,
                clusterClass: "fyh-cluster",
                // see: https://stackoverflow.com/questions/22825620/how-to-make-the-map-clusters-larger-distance-in-less-dense-area-in-map-instead-o
                algorithmOptions: { radius: CommunityMap.CLUSTER_GRID_SIZE },
                // define custom rendering logic for cluster render to use (custom icons and position)
                renderer: {
                    render: (cluster, clusterStats, map) => {
                        var marker = {
                            position: cluster.markers[0].position,
                            icon: {
                                url: CommunityMap.getIconUrlForCluster(cluster, null),
                                scaledSize: new google.maps.Size(CommunitySearch.ICON_SIZE, CommunitySearch.ICON_SIZE)
                            }                            
                        };
                        return new google.maps.Marker(marker);
                    }
                }
                
            }
            CommunityMap._clusterer = new MarkerClusterer(CLUSTERER_OPTIONS);
            CommunityMap._clusterer.render();

            // Now that the clustering has finished (it will udpate on redraw events such as pan and zoom),
            // reset the side results section
            google.maps.event.addListener(CommunityMap._clusterer, 'clusteringend', function () {            
                
                setTimeout(function(){
                    // Create the label for the cluster
                    CommunityMap.createCommunityLabels(CommunityMap._map, CommunityMap._markers, CommunityMap._clusterer);

                    // set attributes needed for feaures such as styling active clusters
                    CommunityMap.setClusterAttributes(CommunityMap._clusterer);

                    CommunityMap.highlightActiveCommunityIcon(null);

                    // create windows for all markers and clusters now that clustering algorithm has finished
                    CommunityMap.createCommunityPopups();
                }, 400);

                // Show preloader when the map moves and triggers this event (NOTE: loader also
                // displays as result of recenter button click and other events such as apply filters
                // click)
                //showPreLoader(_THIS.COMMUNITY_SEARCH_ELEM);

                // If the current zoom or center has shifted from the original set,
                // scroll the user back to the top of the screen since the listings may change
                // and we dont want to be out of position when new data is loaded into the listing
                const CLUSTER_LOADER_DURATION = 200;

                // hide the preloader from the map that may have been raised from 
                // the clicking of the recenter button
                // need to wait for the scroll to complete before allowing user to interact with the page
                setTimeout(function(){
                    //hidePreLoader(_THIS.COMMUNITY_SEARCH_ELEM);

                    // For some unknown reason, after we scroll to 
                    // top of page, the sticky container does NOT set .is-at-top class correctly
                    // and instead the map sticky container is .is-at-bottom...fix this manually 
                    // and set its top to 0
                    // $("#fyh-search-sticky").removeClass("is-at-bottom");
                    // $("#fyh-search-sticky").addClass("is-at-top");
                    // $('#fyh-search-sticky').css({top: 0});
                }, CLUSTER_LOADER_DURATION);

                // Update lat/lng and zoom tracker to restore map state on mobile map tab click
                CommunityMap.setLastMapCenterAndZoom(CommunityMap._map.getCenter(), CommunityMap._map.getZoom());

                // make sure pricing tooltips are initialized now that DOM has been altered (sorting, etc.)
                CommunityMap.initPricingTooltips(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find("[data-tooltip]"));
            });

            // handle the mouseover state and change icon to the active/hover state icon 
            google.maps.event.addListener(CommunityMap._clusterer, "mouseover", function (cluster) {
                // get first marker in this cluster and use its guid
                var marker = cluster.markers_[0];
                var guid = marker.customInfo.nodeGuid;
                CommunityMap.highlightActiveCommunityIcon(guid);
            });

            // handle the mouseout state and change back to the default icon
            google.maps.event.addListener(CommunityMap._clusterer, "mouseout", function (cluster) {
                CommunityMap.highlightActiveCommunityIcon(null);
            });
        }
        else {
            CommunityMap.setClusterMarkers(CommunityMap._clusterer, CommunityMap._markers);
            CommunityMap.setClusterAttributes(CommunityMap._clusterer);
            //CommunityMap._clusterer.render();
        }

        // If there are zero results, then center the map on Chicago (approximate center of USA) and set it to max zoom
        if( communitySearchMapJsonV2 == null || communitySearchMapJsonV2.length < 1 ) {
            // Define default center and zoom to use
            var center = new google.maps.LatLng(CommunityMap.DEFAULT_INITIAL_POSITION_LAT, CommunityMap.DEFAULT_INITIAL_POSITION_LONG) // Lat and Long of Chicago
            
            // if we have an intiial center position, go back to it
            if (CommunityMap._initialCenterPosition != null ) {
                CommunityMap.resetMapCenterAndZoom();
            }
            //CommunityMap.render();

            var zoom = CommunityMap.DEFAULT_INITIAL_ZOOM;

            // Set the center and zoom for the map and record it for use later
            CommunityMap._map.setCenter(center);
            CommunityMap._map.setZoom(zoom);
            CommunityMap.setMapCenterAndZoom(center, zoom);

            _THIS.COMMUNITY_SEARCH_ELEM.find("#region-map-no-results-overlay").show();
            
        }

        // Create Legend only if this is the first initialization (ie.g., not updating markers)
        if (onlyUpdateData === false) {
            var legend = document.getElementById("fyh-search-legend");
            if (legend != null) {
                CommunityMap._map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);
            }
        }

        // Set zoom depending on markers
        // Event signals map is finished loading so record the zoom level
        // calculated by the initial set of fitBounds() invocations based on all markers
        var fyhSearchMapIdleListener = google.maps.event.addListenerOnce(CommunityMap._map, 'idle', function () {
            // Map is now idle after creating first round of markers, grab the zoom level, record
            // it, and set the map's min zoom (zooming out further equates to smaller zoom level number)
            CommunityMap._initialZoom = CommunityMap._map.getZoom();
            CommunityMap._map.setOptions({
                maxZoom: CommunityMap.MAX_ZOOM
            });
            CommunityMap._map.setZoom(CommunityMap._initialZoom);

            if (CommunityMap._clusterer != null) {
                //CommunityMap.fyhSearchMapClusterer.setGridSize(CommunityMap.FYH_SEARCH_CLUSTER_GRID_SIZE);
                CommunityMap.setClusterAttributes(CommunityMap._clusterer);
                //CommunityMap._clusterer.render();
            }

            // record the fyh map center and zoom so we can later reset and zoom to this setting on Recenter Button click
            var centerAfterIdle = CommunityMap._map.getCenter();
            var zoomAfterIdle = CommunityMap._map.getZoom();
            CommunityMap.setMapCenterAndZoom(centerAfterIdle, zoomAfterIdle);

            // Update lat/lng and zoom tracker to restore map state on mobile map tab click
            CommunityMap.setLastMapCenterAndZoom(CommunityMap._map.getCenter(), CommunityMap._map.getZoom());
        });

        if ( CommunityMap._clustererHoverListener != null ) {
            google.maps.event.removeListener(CommunityMap._clustererHoverListener);
        }
        // Create InfoWindow popup on click event for mobile or mouseover for desktop
        var clusterEventName = 'click';
        if (Foundation.MediaQuery.atLeast('xlarge')) {
            clusterEventName = "mouseover";
        }
        CommunityMap._clustererHoverListener = google.maps.event.addListener(CommunityMap._clusterer, clusterEventName, function (cluster) {
            // Only proceed with popup logic if we are at the max zoom for this map
            var currentZoom = CommunityMap._map.getZoom();
            if (currentZoom == CommunityMap.MAX_ZOOM) {

                // find the marker that has the guid of interest
                var allClusterMarkerGuids = "";

                var markers = cluster.markers;
                markers.forEach(function (marker, index) {
                    var markerGuid = marker.customInfo.nodeGuid;

                    // Compile "|" delimited list of guids this cluster represents
                    allClusterMarkerGuids += markerGuid;
                    if (index < markers.length - 1) {
                        allClusterMarkerGuids += "|";
                    }
                });

                var infoWin = CommunityMap._communityPopups[allClusterMarkerGuids];
                if (infoWin) {
                    infoWin.open();
                    CommunityMap._activeCommunityPopups = infoWin;
                }
            }
        });

        // now that data has been updates, reset any active markers/labels
        CommunityMap.highlightActiveCommunityIcon(null);

        CommunityMap.initPricingTooltips(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find("[data-tooltip]"));
    }

    /**
     * Handles View More button click within the FYH Search Results panel
     */
    // fyhSearchResultsViewMore() {
    //     const _THIS = this;
    //     if (communitySearchMapJsonV2 != null) {

    //         // Grab current number of visible results and the number of results to attempt to fetch
    //         var numVisibleResults = CommunityMap._visibleCommunityGuids.length;
    //         var numResultsToDisplay = CommunityMap._numResultsDisplayed + CommunityMap.RESULTS_LISTING_BATCH_SIZE;
    //         // Loop through the next batch of results
    //         var loopCount = 0;
    //         for (var x = CommunityMap._numResultsDisplayed; x < numVisibleResults && x < numResultsToDisplay; x++) {
    //             var communityNodeGuid = CommunityMap._visibleCommunityGuids[x];
    //             // Make this card visible
    //             var card = _THIS.COMMUNITY_SEARCH_ELEM.find(".search-results_wrapper-cell[data-node-guid=" + communityNodeGuid + "]");
    //             if (card != null && card.length > 0) {
    //                 card.addClass("is-visible");
    //                 if (loopCount == 0) {
    //                     // Try to check first if we have a new clickable element on the clients section.
    //                     var nextElementToFocus = card.find("button").first();
    //                     if (nextElementToFocus.length) {
    //                         nextElementToFocus.focus();
    //                     }
    //                 }
    //             }

    //             // Increment the visible result count
    //             CommunityMap._numResultsDisplayed++;
    //             loopCount++;
    //         }

    //         // Decide if we need to hide the view more button or not
    //         if (CommunityMap._numResultsDisplayed < numResultsToDisplay || CommunityMap._numResultsDisplayed >= numVisibleResults) {
    //             _THIS.COMMUNITY_SEARCH_ELEM.find(".view-more-communities").hide();
    //         }
    //         else {
    //             _THIS.COMMUNITY_SEARCH_ELEM.find(".view-more-communities").show();
    //         }
    //         // Update the number of results based on the number of DOM elements (which indicates total number of query results)
    //         this.updatedDisplayCount();
    //     }
    // }


    /**
     * Update display count according to the total number of markers/communities
     * visible in the map viewport 
     */
    updateDisplayCount() {
        const _THIS = this;

        // NUmber of results is derived from the number of results in the json
        let numResults = window.communitySearchMapJsonV2.length;
        $(".home-search-form-num-results, .search-results-cards-num-results-v2").text(`${numResults} Community Results`);

        if (numResults < 1) { 
            _THIS.COMMUNITY_SEARCH_ELEM.find("#region-map-no-results-overlay").show();
        }
    }
    /**
     * Sorts the side results section according to the selected value of the sort dropdown list
     */
    sortCommunityJson(){
        const _THIS = this;
        var selectedSort = _THIS.COMMUNITY_SEARCH_ELEM.find("#sort-dropdown").val();

        var sortFunc = _THIS.getSortCommunityByAlpaAscFunc();
        switch (selectedSort) {
            case 'alpha_a-z':
                sortFunc = _THIS.getSortCommunityByAlpaAscFunc();
                break;
            case 'alpha_z-a':
                sortFunc = _THIS.getSortCommunityByAlpaDescFunc();
                break;
            case 'price_low-high':
                sortFunc = _THIS.getSortCommunityByPriceAscFunc();
                break;
            case 'price_high-low':
                sortFunc = _THIS.getSortCommunityByPriceDescFunc();
                break;
            case 'location_a-z':
                sortFunc = _THIS.getSortCommunityByLocationAscFunc();
                break;
            case 'location_z-a':
                sortFunc = _THIS.getSortCommunityByLocationDescFunc();
                break;
        }

        communitySearchMapJsonV2 = communitySearchMapJsonV2.sort(sortFunc);
        return communitySearchMapJsonV2
    }

    /**
     * Sorts the side results section according to the selected value of the sort dropdown list
     */
    sortCommunityCardsDOM(){
        const _THIS = this;
        var selectedSort = _THIS.COMMUNITY_SEARCH_RESULTS_ELEM.find("#sort-dropdown").val();

        var cards = _THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find('.card-v2');        
       
        switch (selectedSort) {
            case 'alpha_a-z':
                // Sort DOM
                $(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find('.card-v2').parent()).html(cards.sort(function(a,b){
                    var aObject = {
                        Name: $(a).data("name")
                    }
                    var bObject = {
                        Name: $(b).data("name")
                    }
                    return _THIS.getSortCommunityByAlpaAscFunc()(aObject, bObject);
                }));
                break;
            case 'alpha_z-a':
                // Sort DOM
                $(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find('.card-v2').parent()).html(cards.sort(function(a,b){
                    var aObject = {
                        Name: $(a).data("name")
                    }
                    var bObject = {
                        Name: $(b).data("name")
                    }
                    return _THIS.getSortCommunityByAlpaDescFunc()(aObject, bObject);
                }));
                break;
            case 'price_low-high':
                // Sort DOM
                $(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find('.card-v2').parent()).html(cards.sort(function(a,b){
                    var aObject = {
                        Name: $(a).data("name"),
                        PriceMin: $(a).data("start-price")
                    }
                    var bObject = {
                        Name: $(b).data("name"),
                        PriceMin: $(b).data("start-price")
                    }
                    return _THIS.getSortCommunityByPriceAscFunc()(aObject, bObject);
                }));
                break;
            case 'price_high-low':
                // Sort DOM
                $(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find('.card-v2').parent()).html(cards.sort(function(a,b){
                    var aObject = {
                        Name: $(a).data("name"),
                        PriceMin: $(a).data("start-price")
                    }
                    var bObject = {
                        Name: $(b).data("name"),
                        PriceMin: $(b).data("start-price")
                    }
                    return _THIS.getSortCommunityByPriceDescFunc()(aObject, bObject);
                }));
                break;
            case 'location_a-z':
                $(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find('.card-v2').parent()).html(cards.sort(function(a,b){
                    var aObject = {
                        Name: $(a).data("name"),
                        State: $(a).data("state"),
                        City: $(a).data("city")
                    }
                    var bObject = {
                        Name: $(b).data("name"),
                        State: $(b).data("state"),
                        City: $(b).data("city")
                    }
                    return _THIS.getSortCommunityByLocationAscFunc()(aObject, bObject);
                }));
                break;
            case 'location_z-a':
                $(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find('.card-v2').parent()).html(cards.sort(function(a,b){
                    var aObject = {
                        Name: $(a).data("name"),
                        State: $(a).data("state"),
                        City: $(a).data("city")
                    }
                    var bObject = {
                        Name: $(b).data("name"),
                        State: $(b).data("state"),
                        City: $(b).data("city")
                    }
                    return _THIS.getSortCommunityByLocationDescFunc()(aObject, bObject);
                }));
                break;
        }

        // Restore each tooltips title attr with its data-title attribute (after init, foudnation clears the title
        // attr value and therefore we need to restore it before initializing them again)
        var pricingTooltips = $(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find(".pricing-tooltip"));
        pricingTooltips.each((index, elem) => {
            $(elem).attr("title", $(elem).data("title"));
            // no need to reinitialize now that will be handled in code after this
        });
    }

    /**
     * 
     * @returns 
     */
    getSortCommunityByAlpaAscFunc() {
        const _THIS = this;
        return function(a,b) {
            if (a.Name.toLowerCase() < b.Name.toLowerCase()) { return -1; }
            else if (a.Name.toLowerCase() > b.Name.toLowerCase()) { return 1; }
            else { return 0; }
        };
    }

   /**
    * 
    * @returns 
    */
    getSortCommunityByAlpaDescFunc() {
        const _THIS = this;
        return function(a,b){
            return -1 * _THIS.getSortCommunityByAlpaAscFunc()(a,b);
        }
        
    }

    /**
     * 
     * @returns 
     */
    getSortCommunityByPriceAscFunc() {
        const _THIS = this;
        return function(a,b){
            if (a.PriceMin < b.PriceMin) { return -1; }
            else if (a.PriceMin > b.PriceMin) { return 1; }
            else {
                return _THIS.getSortCommunityByAlpaAscFunc()(a,b);
            }
        }
        
    }

   /**
    * 
    * @returns 
    */
    getSortCommunityByPriceDescFunc() {
        const _THIS = this;
        return function(a,b){
            if (a.PriceMin > b.PriceMin) { return -1; }
            else if (a.PriceMin < b.PriceMin) { return 1; }
            else {
                return _THIS.getSortCommunityByAlpaAscFunc()(a,b);
            }
        }
    }

    /**
     * 
     * @returns 
     */
    getSortCommunityByLocationAscFunc() {
        const _THIS = this;
        return function(a,b){
            if (a.State < b.State) { return -1; }
            else if (a.State > b.State) { return 1; }
            else {
                if (a.City < b.City) { return -1; }
                else if (a.City > b.City) { return 1; }
                else {
                    // Name in ascending fashion
                    return _THIS.getSortCommunityByAlpaAscFunc()(a,b);
                }
            }
        }       
    }

    /**
     * 
     * @returns 
     */
    getSortCommunityByLocationDescFunc() {
        const _THIS = this;
        return function(a,b){
            if (a.State > b.State) { return -1; }
            else if (a.State < b.State) { return 1; }
            else {
                if (a.City > b.City) { return -1; }
                else if (a.City < b.City) { return 1; }
                else {
                    // Name in ascending fashion
                    return _THIS.getSortCommunityByAlpaAscFunc()(a,b);
                }
            }
        }    
    }

    /**
     * Resets the FYH search results panel by resetting the num results dispalyed counter and resetting
     * the visible community data structure. Also hides all the communities in the results section and attempts
     * to load in a new fresh batch of visible communities.
     */
    resetSearch() {
        const _THIS = this;
        CommunityMap._visibleCommunityGuids = [];
        CommunityMap._numResultsDisplayed = 0;

        // Remove the is-visible class from the results
        //_THIS.COMMUNITY_SEARCH_ELEM.find(".search-results_wrapper-cell").removeClass("is-visible");

        // By default hide the view more button
        //_THIS.COMMUNITY_SEARCH_ELEM.find(".view-more-communities").hide();

        // Get list of all markers and update global fyhSearchVisibleCommunityNames
        if (CommunityMap._clusterer != null) {
            //var allClusters = CommunityMap.fyhSearchMapClusterer.getClusters();
            var allClusters = CommunityMap._clusterer.clusters;
            var visibleClusters = [];
            allClusters.forEach(function (cluster) {
                if (CommunityMap._map.getBounds().contains(cluster.position) === true) {
                    visibleClusters.push(cluster);
                }
            });

            // Now that we have all the visible clusters, loop through each cluster to get each marker
            // so that we can hide
            var visibleCommunityGuids = [];

            visibleClusters.forEach(function (cluster) {
                var markers = cluster.markers;
                markers.forEach(function (marker) {
                    var communityNodeGuid = marker.customInfo.nodeGuid;

                    // Add this community to visible community data structure
                    visibleCommunityGuids.push(communityNodeGuid);
                });
            });

            // Sort communitySearchMapJsonV2nd update CommunityMap.fyhSearchCommunityNodeGuidsSorted
            communitySearchMapJsonV2 = _THIS.sortCommunityJson();
            CommunityMap._communityGuidsSorted = communitySearchMapJsonV2.map(function(community){
                return community.NodeGUID;
            });

            // Reset the map and set the visible community data structure...Order the visible community list according current sort selection
            CommunityMap._communityGuidsSorted.forEach( function(communityGuid){
                if( visibleCommunityGuids.includes(communityGuid) ){
                    CommunityMap._visibleCommunityGuids.push(communityGuid);
                }
            });


        }

        // Now Sort Results DOM
        this.sortCommunityCardsDOM();

        // Now that DOM has changed, make sure to re-init the favoriting
        initFavoriteButtons(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find(".card-like-button"));

        // Try loading initial batch of results
        //this.fyhSearchResultsViewMore();

        // Update the number of results based on the number of DOM elements (which indicates total number of query results)
        this.updateDisplayCount();

        // Add event listener to on hover on listing cards to highlight the active community
        CommunityMap.initResultListingListeners();
    }

    /* Init the FYH Screen size
    *
    * Used to detect the screen size of the search-results card for medium and up a heigh setting should be placed
    * So the footer can be placed at the proper location. On Mobile it's set to no height. If screen is re-oriented,
    * the function is run again with a delay
    */
    // initFYHSearchResultsScreen() {
    //     const _THIS = this;
    //     // Make the FYH Search Results map and the results section to consume the remaining view port space under the nav
    //     if (_THIS.COMMUNITY_SEARCH_MAP_ELEM.length > 0 && $(".home-search-form").length > 0) {
    //         // Use dynamic sizing if this is an xxlarge device or higher, OR if this is a large device used in portrait mode
    //         if (Foundation.MediaQuery.atLeast('xxlarge') === true || (Foundation.MediaQuery.atLeast('large') === true && window.innerHeight > window.innerWidth)) {
    //             // Subtract the combined height of the header and filter form from the viewport to
    //             // get the remaining space
    //             var spaceBelowForm = $(window).height() - ($("header").outerHeight(true) + $(".home-search-form").outerHeight(true) + $("footer").outerHeight(true));
    //             spaceBelowForm = Math.floor(spaceBelowForm);
    //             _THIS.COMMUNITY_SEARCH_MAP_ELEM.height(spaceBelowForm);
    //             _THIS.COMMUNITY_SEARCH_ELEM.find(".search-results").height(spaceBelowForm);
    //             _THIS.COMMUNITY_SEARCH_ELEM.find(".search-results").css("max-height", spaceBelowForm);
    //         }
    //         else if (Foundation.MediaQuery.atLeast('medium') === true) {
    //             // Just set the results section to match height of map
    //             var mapHeight = _THIS.COMMUNITY_SEARCH_MAP_ELEM.outerHeight(true);
    //             _THIS.COMMUNITY_SEARCH_ELEM.find(".search-results").height(mapHeight);
    //             _THIS.COMMUNITY_SEARCH_ELEM.find(".search-results").css("max-height", mapHeight);
    //         }
    //         else if (Foundation.MediaQuery.atLeast('small') === true) {
    //             // Just set the results section to match height of map
    //             var mapHeight = 'unset';
    //             _THIS.COMMUNITY_SEARCH_ELEM.find(".search-results").height(mapHeight);
    //             _THIS.COMMUNITY_SEARCH_ELEM.find(".search-results").css("max-height", mapHeight);
    //         }
    //         //re-run function when orientation changes
    //         window.addEventListener("orientationchange", function () {
    //             //set delay before function is rerun
    //             var screenTimer = setInterval(myTimer, 1000);
    //             function myTimer() {
    //                 initFYHSearchResultsScreen();
    //             }
    //         });
    //     }
    // }

    /**
     * Forces the map to remove all markers and recreate markers given the latest map JSON dataset.
     *
     * Intended to be called by backend with json string to refresh map markers
     *
     * See: window.communitySearchMapJsonV2    */
    refreshMap(onlyUpdateData = false) {
        // Data from BE will be stored in hidden field textbox
        if (IS_LOCALHOST === false) {
            var jsonData = JSON.parse(this.COMMUNITY_SEARCH_COMMUNITY_DATA_ELEM.val());

            if (jsonData) {
                window.communitySearchMapJsonV2 = jsonData;
            }
        }

        // Trigger re-init
        this.initMapAndData(onlyUpdateData);

    }

    /**
     * Invoke this function to generate `getCommunities` function instance
     * @returns Closure based invocation of `getCommunities()` so that it can be 
     * invoked by other classes/objects while maintaing the this keyword to this class instance
     */
    buildGetCommunitiesFunc(){
        const _THIS = this;
        return function(data) {
            _THIS.getCommunities(data)
                .then((data) => {
                    // Re-bind the photo gallery button event listeners 
                    initCommunityPhotoGalleryButtons(); 
                    // Init the media-modal elements
                    $(".media-modal").foundation();
                    initMediaModals($(".media-modal")); 
                })
                .catch((error => console.log(error)))
                .finally(() => {
                    window.hidePreLoader()
                });
        }
    }

    // /**
    //  * Perform AJAX call to load in communities and load them into the UI
    //  */
    getCommunities( formData){
        console.log("fetching communities...");
        const _THIS = this;
        return new Promise(function (resolve, reject) {
            try {
                // Get Anti-CSRF token
                var csrfTokenElem = _THIS.COMMUNITY_SEARCH_ELEM.find('[name="__RequestVerificationToken"]');
                let csrfToken = csrfTokenElem.val();
                $.ajax({
                    type: "GET",
                    url: _THIS.ENDPOINT,
                    data: formData,
                    traditional: true,  // needed for data to be sent correctly to backend
                    contentType: "application/json; charset=utf-8",
                    cache: false,
                    dataType: "json",
                    beforeSend: function (request) {
                        if (csrfToken) {
                            request.setRequestHeader("__RequestVerificationToken", csrfToken);
                        }
                        window.showPreLoader();

                        _THIS.COMMUNITY_SEARCH_ELEM.find("#region-map-no-results-overlay").hide();
                    },
                    success: function (response) {
                        if ((response != null)) {
                            if (resolve) {
                                resolve(response);
                            }

                            // Remove markup from listing and replace with markup from backend
                            _THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.empty();
                            _THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.append(response.CommunityMarkup);

                            // Update the hidden community data json data for the map rendering
                            _THIS.COMMUNITY_SEARCH_COMMUNITY_DATA_ELEM.val(response.CommunityJson)
                            //_THIS.initMap();
                            _THIS.refreshMap(false);

                            // close the mobile filter form (timeout needed for weird bug where foundation
                            // does not remove overflow-y hidden style from the .is-reveal-open class on the body)
                            setTimeout(() => {
                                $("#home-search-form-wrapper-mobile").foundation("close");
                                window.hidePreLoader();
                            }, 1000);

                            // Reinit preloader
                            //window.initPreLoader();

                            // TODO: Add legacy code
                            // 1. Update data layer with selected region and state
                            // 2. invoke window.atlasRTXHelper.rebuildData()

                            // re-init the reveal modal for image and video gallery
                            //window.Foundation.reflow($(".galleryHeroPhotoModal"), 'reveal');
                            //window.Foundation.reflow($(".galleryHeroVideoModal"), 'reveal');

                            // re-init carousel binding with buttons
                            if (_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM && _THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.length > 0)
                            {
                                initMediaWithThumbnailCarousels(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM[0]);
                            }
                            else {
                                // Show the No results found 
                                _THIS.COMMUNITY_SEARCH_ELEM.find("#region-map-no-results-overlay").show();
                            }
                            

                            // lazy load images
                            lozadObserver();

                            // init favorite buttons
                            initFavoriteButtons(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find(".card-like-button"));

                            CommunityMap.initPricingTooltips($(_THIS.COMMUNITY_SEARCH_RESULTS_LIST_ELEM.find("[data-tooltip]")));

                            // Update the region and state filter
                            //CommunitySearchFilters.updateFilterBtnText(response.SelectedStateName, response.SelectedRegionName)
                        }
                        else {
                            if (reject) reject(response);
                        }
                    },
                    error: function (request, textStatus, errorThrown) {
                        if (reject) reject("AJAX error: " + request.statusText);
                    }
                })
            }
            catch (err) {
                if (reject) reject("Error occurred fetching community data:" + err);
            }
        });
    }    
}

window.CommunitySearch = CommunitySearch;
// window.communitySearchJsLoaded = new CustomEvent("communitySearchJsLoaded", {
//     detail: {
//       message: "communitySearchJsLoaded js loaded"
//     }
//   });
// window.dispatchEvent(window.communitySearchJsLoaded);
// window.isCommunitySearchJsLoaded = true;

export default CommunitySearch;
//export default CommunitySearch;

